import { FORMIK_INITIAL_VALUES, FormType } from '../keys';

export const getInitialFormValues = (merchantName?: string, merchantUuid?: string): FormType => {
  return {
    ...FORMIK_INITIAL_VALUES,
    name: merchantName ?? '',
    uuid: merchantUuid ?? '',
  };
};
